import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

export const useOnCloseCalendar = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  return () => {
    navigate(navigation.calendar.fullPath())
  }
}
